module.exports = __webpack_public_path__ + "static/media/close-button-icon.bb62e379.svg";